<template>
  <div class="p-0 mb-3 mt-5 pt-5 col-md-10 mx-auto" style="margin-top: 5rem!important;">
    <div>
      <get-panels-number class="col-md-10 mx-auto" panel-type="car_business"></get-panels-number>

      <v-btn class="submit-btn text-white ml-26" @click="syncMarketPlace">
        <span class="material-icons" style="font-size: 14pt">save</span>
        تایید
      </v-btn>
    </div>

    <div v-if="isConfirmed" class="p-0 mt-5 mb-3 pt-5" style="border: none!important;">
      <div class="mb-3 col-md-10 mx-auto">
        <pay-ladder-component v-model="payLadder" :phone="selectedNumber"/>
        <CarAddList :market-number="marketNumber" :market-number-id="marketNumberId"></CarAddList>
      </div>

      <div class="col-md-10 px-3 mx-auto my-0 py-0" style="border-top:1px #7e8299 dashed">
        <v-radio-group
          v-model="timing"
          column>
          <v-radio
            color="indigo"
            label="تدریجی اتوماتیک: تقسیم آگهی ها بین ساعت شروع تا ساعت پایان"
            value="auto"
          ></v-radio>
          <v-radio
            color="indigo"
            label=" تدریجی زماندار: براساس زمان انتخاب شده"
            value="gradual"
          ></v-radio>
        </v-radio-group>

      </div>
      <div v-if="timing === 'gradual'" class="col-md-10 px-3 mx-auto py-1">
        <v-switch v-model="isDay" class="my-3" color="indigo darken-3" hide-details
                  label="براساس تاریخ"></v-switch>
        <div v-for="(item,index) in count" v-if="isDay === true" class="d-flex">
          <multi-times :key="item" :ref="item" :autoGradual="timing === 'auto'"></multi-times>
          <v-btn class="mx-1 mr-2" color="success" icon outlined small
                 @click="count.push(Math.random())">
            <i class="fa fa-plus text-success" style="font-size: 9pt"></i>
          </v-btn>
          <v-btn v-if="count.length > 1" class="mx-1" color="error" icon outlined small
                 @click="removeDate(index)">
            <i class="fa fa-minus text-danger" style="font-size: 9pt"></i>
          </v-btn>
        </div>
        <div v-if="isDay===false" class="py-1">
          <timr-with-days ref="withDays" :autoGradual="timing === 'gradual'"></timr-with-days>
        </div>
      </div>

      <div v-if="timing === 'auto'" class="col-md-10 px-3 mx-auto py-1">
        <v-switch
          v-model="isDay"
          class="my-3"
          color="indigo darken-3"
          hide-details
          label="براساس تاریخ"
        ></v-switch>
        <div v-for="(item,index) in count" v-if="isDay === true" class="d-flex">
          <multi-times :key="item" :ref="item"></multi-times>
          <v-btn class="mx-1 mr-2" color="success" icon outlined small
                 @click="count.push(Math.random())">
            <i class="fa fa-plus text-success" style="font-size: 9pt"></i>
          </v-btn>
          <v-btn v-if="count.length > 1" class="mx-1" color="error" icon outlined small
                 @click="removeDate(index)">
            <i class="fa fa-minus text-danger" style="font-size: 9pt"></i>
          </v-btn>
        </div>
        <div v-if="isDay===false" class="py-1">
          <timr-with-days ref="withDays"></timr-with-days>
        </div>
      </div>

      <div v-if="timing === 'gradual'" class="row col-md-10 mx-auto px-0">
        <div class="col-md-6">
          <v-text-field v-model.number="newSchema['per']" :rules="[v => !!v || 'این فیلد الزامی است']"
                        append-inner-icon="fa fa-pencil-alt"
                        clear-icon="mdi-close-circle-outline"
                        clearable dense hint="بر اساس دقیقه/از 1 دقیقه تا 120 دقیقه میتوانید درج کنید."
                        label="فاصله زمانی بین هر آگهی (دقیقه)" max="120"
                        min="1"
                        oninput="if(Number(this.value) > Number(this.max) && this.type === 'number') this.value = this.max; else if(Number(this.value) < Number(this.min) && this.type === 'number') this.value = this.min;"
                        outlined
                        type="number"/>
        </div>
      </div>

      <div class="col-md-10 px-3 mx-auto py-1">
        <v-text-field v-model="newSchema.smart_payload.nickname" clearable dense label="نام مستعار" outlined/>
      </div>

      <div class="col-md-10 mr-auto">
        <v-btn :loading="loading" class="submit-btn float-left" @click="sendSmartAds">
          <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
          ثبت نردبان تدریجی
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import InputMaker from "@/view/pages/ads/inputMaker";
import AdsSelector from "@/view/pages/ads/adsSelector";
import Inputs from "@/view/pages/ads/inputs";
import NumberSelector from "@/view/pages/ads/numberSelector";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import CitySelector from "@/view/pages/ads/citySelector";
import Categoryselector from "@/view/pages/ads/categorySelector";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import SimilarAds from "@/view/pages/ads/similarAds/similarAds";
import ownAds from "@/view/pages/ads/sendAds/ownAds";
import {Bus} from "@/main";
import MultiTimes from "@/view/pages/ads/sendAds/multiTimes";
import TimrWithDays from "@/view/pages/ads/sendAds/timrWithDays";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import ShopAdsList from "@/view/pages/ladderShop/shopAdsList";
import GetPanelsNumber from "@/view/pages/ads/singleAds/agency/getPanelsNumber";
import PayLadderComponent from "@/view/pages/ladderShop/payLadderComponent";
import CarAddList from "@/view/pages/ads/panels/ladder/carAdsList.vue";

export default {
  name: "CarGradual",
  components: {
    CarAddList,
    PayLadderComponent,
    GetPanelsNumber,
    ShopAdsList,
    ButtonTempl,
    TimrWithDays,
    MultiTimes,
    SimilarAds,
    TitleRibbon,
    InputMaker,
    AdsSelector,
    Inputs,
    NumberSelector,
    Automatics,
    CitySelector,
    Categoryselector,
    ownAds
  },
  props: {
    divar: {
      required: true
    },
    own: {
      required: true
    },
    ads: {
      required: true
    },
    multi_time: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: "ارسال آگهی هوشمند"
    },
    cats: {
      default: ''
    }

  },
  data() {
    return {
      isConfirmed: false,
      picker: '',
      timing: 'auto',
      numberId: '',
      count: [1],
      autoChange: false,
      requireAds: false,
      isSmart: true,
      schema: {
        advertise: {
          category: "",
          location: {
            city: "",
            neighborhood: ""
          },
          images: [],
          contact: {
            chat_enabled: false,
            hide_phone: false,
            phone: null
          },
        },
        available_at: '',
        expire_at: '',
      },
      multiTimes: {},
      newSchema: {
        type: "minute",
        kind: "car",
        search_payload: {'value': null},
        smart_payload: {
          nickname: ''
        },
      },
      myCategory: '',
      isDay: false,
      selected: [],
      marketNumber: '',
      payLadder: {
        wallet: true
      },
      marketNumberId: '',
      maxCount: '',
      loading: false,
      selectedNumber: undefined
    }
  },
  methods: {
    getSchema: function (value) {
      this.ui_schema = value;
    },
    getFields: function (val) {
      this.fields = val;
    },
    removeDate(index) {
      this.count.splice(index, 1)
    },
    sendSmartAds(number = 0) {
      const keys = Object.keys(this.multiTimes);

      if (keys.length > 0)
        var param = {
          ...this.newSchema,
          start_at: this.multiTimes[keys[0]].started,
        }

      this.loading = true
      $.ajax({
        url: `${url}/smarts`,
        method: 'POST',
        fn: this.sendSmartAds,
        params: [number],
        msg: true,
        headers: {
          ACCEPT: 'application/json',
          'Content-Type': 'application/json',
          Authorization: Token
        },
        data: JSON.stringify(keys.length > 0 ? param : this.newSchema),
        success: (data) => {
          this.loading = false
        },
        error: (data) => {
          this.loading = false
        }
      })
        .always(data => {
          number++;
          if (number < keys.length)
            this.sendSmartAds(number);
        });
    },
    syncMarketPlace() {
      this.isConfirmed = true;
      this.marketNumberId = this.numberId;
      this.marketNumber = '';
    }
  },
  watch: {
    isDay: function (value) {
      if (value === true) {
        delete this.newSchema['days']
        delete this.newSchema['start_time']
        delete this.newSchema['end_time']
        Bus.$on('getTimeMode', (moment) => {
          this.newSchema['expire_at'] = moment.end;
          this.newSchema['start_at'] = moment.started;
          this.newSchema['count'] = 1;
          // this.newSchema.smart_payload['repeat'] = moment.repeat;
        })
      }
    },
    marketNumberId: function (val) {
      this.schema.advertise.contact.phone = val
    },
    isConfirmed(value) {
      if (value) {
        this.newSchema.smart_payload['number_id'] = this.numberId
      }
    },
    timing(val) {
      if (val === "auto")
        this.newSchema['per'] = -1;
      else
        this.newSchema['per'] = null;
    },
    'payLadder.wallet'(val) {
      this.newSchema.smart_payload['wallet'] = val;
    }
  },
  mounted() {
    this.newSchema.smart_payload['wallet'] = this.payLadder.wallet;
    if (this.isDay === false) {
      Bus.$on('getDayMode', (values) => {
        this.newSchema['days'] = values.day;
        this.newSchema['start_time'] = values.start;
        this.newSchema['end_time'] = values.end;
      })
    }

    if (this.timing === "auto") {
      this.newSchema['per'] = -1
    } else
      this.newSchema['per'] = null;


    Bus.$on('selected_numbers', (val) => {
      this.numberId = val
    });

    Bus.$on('rp_selected_number', (val) => {
      this.selectedNumber = val
    });

    Bus.$on("getTimeMode", (value, key) => {
      this.multiTimes[key] = value;
    })
    Bus.$on("maxCountOfLadder", (value, key) => {
      this.maxCount = value.remaining;
    })
    Bus.$on("selectedAds", (value, key) => {
      this.newSchema.smart_payload['advertises'] = value;
    })

    Bus.$on("currentTab", (value, key) => {
      this.newSchema.smart_payload['tab'] = value;
    })
  }
}
</script>

<style scoped>

</style>